import contentSwitcher from '../content-switcher/content-switcher';
import isElement from '../../scripts/util/isElement';
import isViewport from '../../scripts/util/window/isViewport';
import {lg} from '../../scripts/util/window/isViewport';
import ScrollMagic from 'ScrollMagic';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
import 'animation.gsap';
import addClass from '../../scripts/util/DOM/addClass';
import isMobile from 'ismobilejs';
import question from '../support/question';
import popup from '../support-category/popup';
import $ from 'jquery';

const selectors = {
	page: '.js-guide-page',
	devices: {
		trigger: '.js-devices-trigger',
		mac: '.js-guide-mac',
		iphone: '.js-guide-iphone',
		ipad: '.js-guide-ipad'
	},
	section: {
		trigger: '.js-trigger-section'
	},
	sidebar: '.js-accordeon',
	sidebarItem: '.js-content-with-aside__aside .js-list-item',
	content: '.js-content-with-aside',
	filter: '.js-accordeon',
	box: '.js-filter-box',
	contentMain: '.content-with-aside__cont'
};

const classes = {
	animation: 'guide__devices_will_animate',
	fixed: 'mod--menu-fixed',
	fixedBottom: 'mod--menu-fixed-bottom'
};

const removeMod = () => {
	const triggerDevices = document.querySelector(selectors.devices.trigger);
	triggerDevices.classList.remove(classes.animation);
};

const addMod = () => {
	const triggerDevices = document.querySelector(selectors.devices.trigger);
	addClass(classes.animation)(triggerDevices);
};

const animate = controller => {
	const devices = selectors.devices;
	const doc = document;
	const triggerDevices = doc.querySelector(devices.trigger);
	const mac = doc.querySelector(devices.mac);
	const iphone = doc.querySelector(devices.iphone);
	const ipad = doc.querySelector(devices.ipad);

	const tweenDevices = new TimelineMax()
		.add([
			TweenMax.to(mac, 3, {y: -420, ease: 'easeOut'}),
			TweenMax.to(iphone, 3, {y: 200, ease: 'easeOut'}),
			TweenMax.to(ipad, 3, {y: -185, ease: 'easeOut'})
		]);

	const scene = new ScrollMagic.Scene({
		triggerElement: triggerDevices,
		triggerHook: 'onCenter',
		offset: -300,
		duration: '100%'
	}).setTween(tweenDevices).addTo(controller);

	return {
		scene,
		tweenDevices,
		controller
	};
};


const setModules = () => {

	if (!isViewport(lg) && isElement(selectors.page) && !isMobile.any) {
		const controller = new ScrollMagic.Controller();
		animate(controller);
		contentSwitcher();
		addMod();
	} else if (isElement(selectors.page)) {
		removeMod();
	}
};

let tempScrollTop = 0;
let currentScrollTop = 0;

const fixedMenu = () => {
	const sidebarOffset = $(selectors.sidebar).offset().top;
	$(window).scroll(function () {
		if ($(window).width() > 1024) {
			if ($(window).scrollTop() > sidebarOffset) {
				if (!$(selectors.content).hasClass(classes.fixed)) {
					$(selectors.content).addClass(classes.fixed);
				}
				const sidebarHeight = $(selectors.filter).height();
				if (sidebarHeight >= $(window).height()) {
					const floatDelta = parseInt(sidebarHeight - $(window).height(), 10);
					currentScrollTop = $(window).scrollTop();
					if (tempScrollTop < currentScrollTop ) {
						$(selectors.filter).css('top', -floatDelta);
					}
					else if (tempScrollTop > currentScrollTop ) {
						$(selectors.filter).css('top', 20);
					}

					tempScrollTop = currentScrollTop;
				}
			} else {
				$(selectors.content).removeClass(classes.fixed);

			} if ($(window).scrollTop() + $(selectors.sidebar).outerHeight() > $(selectors.content).offset().top + $(selectors.content).outerHeight()) {
				$(selectors.content).removeClass(classes.fixed);
				$(selectors.content).addClass(classes.fixedBottom);
				$(selectors.filter).attr('style', '');

			} else {
				$(selectors.content).removeClass(classes.fixedBottom);
			}
		}
	});
};

const initScrollMenu = () => {
	const menuItems = $(selectors.sidebarItem);
	const scrollItems = menuItems.map(function () {
		const item = $($(this).attr('href'));
		if (item.length > 0) {
			return item;
		}
	});
	let lastId;
	menuItems.click(function (e) {
		const href = $(this).attr('href');
		const offsetTop = href === '#' ? 0 : $(href).offset().top;
		$('html, body').stop().animate({
			scrollTop: offsetTop + 5
		}, 1500);
		e.preventDefault();
	});
	$(window).on('scroll', function () {
		const cur = scrollItems.map(function () {
			if ($(this).offset().top < $(window).scrollTop()) {
				return this;
			}
		});

		const current = cur[cur.length - 1];

		const id = current && current.length ? current[0].id : '';
		const selector = '[href=\'#' + id + '\']';
		if (lastId !== id) {
			lastId = id;
			menuItems.removeClass('active').filter(selector).addClass('active');
		}
	});
};

const render = () => {
	setModules();
	window.addEventListener('resize', setModules);
	window.addEventListener('orientationchange', setModules);
	if (isElement('.guide')) {
		question();
		popup();
	}
	if (isElement('.common-guide')) {
		fixedMenu();
		initScrollMenu();
	}
};

export {
	selectors
};

export default render;
